import {Modal} from 'bootstrap';
import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {PermissionsService} from '../../../../Services/permissions.service';

@Component({
  selector: 'app-modal-uninvoiced-shipments',
  templateUrl: './modal-uninvoiced-shipments.component.html',
  styleUrls: ['./modal-uninvoiced-shipments.component.css'],
  standalone: false
})
export class ModalUninvoicedShipmentsComponent implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;

  @Input() vm: any;


  constructor(
    public router: Router,
    private permissionsService: PermissionsService
  ) { }

  get hasReceivableInvoicePermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditReceivableInvoices');
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }
generateInvoice(id, subLedger) {
   //  $('#uninvoicedShipments').modal('hide');
    if (subLedger == 'ar') {
      // $state.go('app.admin.transactions.invoice.form', { invoiceId: 'newAR', shipmentId: id });
      this.router.navigateByUrl('/transactions/invoice/ar/form?invoiceId=newAR&shipmentId=' + id);
    } else {
      this.router.navigateByUrl('/transactions/invoice/ap/form?invoiceId=newAP&shipmentId=' + id);
      // $state.go('app.admin.transactions.invoice.form', { invoiceId: 'newAP', shipmentId: id });
    }
  }
}
